import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DividerModule } from 'primeng/divider';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import { Subscription as SubscriptionService } from '@core/services/subscription';
import { formatAmount, currencySymbol } from '@shared/utils/currency';

@Component({
  selector: 'app-subscription',
  imports: [CommonModule, CardModule, ButtonModule, ProgressSpinnerModule, DividerModule, AccordionModule, TooltipModule],
  templateUrl: './subscription.html',
  styleUrl: './subscription.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Subscription {
  constructor(public subscriptionService: SubscriptionService) {}

  formatAmount(amountCents: number | undefined, currency: string | null | undefined): string {
    if (amountCents === undefined || amountCents === null) return '0.00';
    return formatAmount(amountCents / 100, currency);
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  }

  getAmountDue(): string {
    const totalAmountCents = this.subscriptionService.data()?.subscription?.current_usage?.total_amount_cents || 0;
    const prepaidDollars = this.subscriptionService.data()?.subscription?.wallet?.balance_dollars || 0;

    const totalDollars = totalAmountCents / 100;
    const amountDue = Math.max(0, totalDollars - prepaidDollars);

    const currency = this.subscriptionService.data()?.subscription?.current_usage?.currency;
    return formatAmount(amountDue, currency);
  }

  get prepaidCurrencySymbol(): string {
    return currencySymbol(this.subscriptionService.data()?.subscription?.current_usage?.currency);
  }

  openPortal(): void {
    const portalUrl = this.subscriptionService.data()?.subscription?.portal_url;
    if (portalUrl) {
      window.open(portalUrl, '_blank');
    }
  }
}
